/* eslint-disable check-file/filename-blocklist */
export const LEARN_MORE_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/what-can-guests-see-and-do-on-confluence/';
